<div class="main-panel">
  <ng-container *ngIf="!hasLoadError">
    <div class="value-list-container">
      <ng-container *ngTemplateOutlet="valueListTemplate"></ng-container>
    </div>
  </ng-container>
  <div class="filter-desc" [class.load-error]="hasLoadError">
    <capra-icon icon="icon-warning" *ngIf="hasLoadError"></capra-icon>
    <div [innerHTML]="filterDescription"></div>
  </div>
</div>

<ng-template #valueListTemplate>
  <mode-capra-search-input
    class="search-input"
    data-test="filter-search-input"
    placeholder="Search..."
    size="regular"
    [text]="searchTerm$ | async"
    (textChange)="onSearchTermChanged($event)"
  >
  </mode-capra-search-input>
  <div class="search-subtext">
    <span class="all-or-relevant-hint">
      {{ showRelevantValuesOnly ? 'Only displaying relevant values.' : 'Displaying all values.' }}
    </span>
    <span class="search-results-text" [class.no-search-term]="searchTerm.length === 0">{{
      (visibleFilterValues$ | async).length === 1
        ? '1 item found'
        : (visibleFilterValues$ | async).length + ' items found'
    }}</span>
  </div>
  <mode-loader
    class="loader"
    [class.visible]="showLoader$ | async"
    type="secondaryGreen"
    *ngIf="isLoadingSubject$ | async"
  ></mode-loader>
  <cdk-virtual-scroll-viewport
    itemSize="24"
    class="example-viewport"
    class="value-list"
    *ngIf="(isLoadingSubject$ | async) === false"
  >
    <span class="checkbox-icon option-field">
      <input
        #selectAllInput
        id="filter-select-all"
        name="Select All"
        type="checkbox"
        value="Select All"
        [(checked)]="isAll"
        (click)="onSelectAll()"
        [class.partially-selected]="hasPartialSelection"
      />
      <label class="option-label inline-icon icon-editor-checkbox-light-unchecked" for="filter-select-all">
        <span>(Select All)</span>
      </label>
    </span>
    <ng-container *cdkVirtualFor="let value of visibleFilterValues$ | async; index as i; trackBy: trackByValue">
      <span class="checkbox-icon option-field">
        <input
          id="filter-{{ i }}"
          name="{{ value.value }}"
          type="checkbox"
          value="{{ value.value }}"
          [(ngModel)]="value.selected"
          [checked]="value.selected"
          (change)="onSelectItem()"
        />
        <label class="option-label inline-icon icon-editor-checkbox-light-unchecked" for="filter-{{ i }}">
          <span
            capraTooltip
            tooltipContent="{{ value.label }}"
            [tooltipDelay]="[1000, 0]"
            [class.excluded-option]="value.selected && isExclude"
            [class.null-option]="value.value === null || value.value === undefined"
            >{{ value.label }}</span
          >
        </label>
      </span>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</ng-template>
